/*
 * noore.js — House of Noore storefront behaviour, v2.
 *
 * Dependency-free. Every initialiser exits quietly when its markup is absent,
 * and boot() runs each one in isolation so a single failure cannot silently
 * disable the rest. The cart talks only to Shopify's AJAX Cart API.
 */
(function () {
  'use strict';

  var cfg = window.NooreConfig || {};
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* ------------------------------------------------------------- money */
  function money(cents) {
    var fmt = cfg.moneyFormat || '₹{{amount}}';
    var n = Math.round(Number(cents) || 0) / 100;
    var whole = Math.round(n).toLocaleString('en-IN');
    var dec = n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt
      .replace(/\{\{\s*amount_no_decimals(_with_comma_separator)?\s*\}\}/g, whole)
      .replace(/\{\{\s*amount(_with_comma_separator)?\s*\}\}/g, dec)
      .replace(/<[^>]*>/g, '');
  }

  // "₹1,149" rather than "Rs. 1,149.00": whole rupees, no trailing zeros.
  function rupees(cents) {
    var n = (Number(cents) || 0) / 100;
    var str = n % 1 === 0 ? n.toLocaleString('en-IN') : n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '₹' + str;
  }

  /* ---------------------------------------------------------- fade in
   * The only scroll effect on the site: opacity, once. Content is visible
   * until this runs, and a safety net reveals everything after a moment. */
  function initFade() {
    var els = $$('.n-fade');
    if (!els.length || reduceMotion || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('n-js');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -5% 0px' });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight) el.classList.add('is-in'); else io.observe(el);
    });
    window.setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 2000);
  }

  /* ----------------------------------------------------------- header */
  function initHeader() {
    var header = $('[data-n-header]');
    if (!header) return;
    function setH() { document.documentElement.style.setProperty('--n-header-h', header.offsetHeight + 'px'); }
    setH();
    window.addEventListener('resize', setH);
  }

  /* ------------------------------------------------------ rotators */
  function rotator(slides, interval, onChange) {
    var i = 0, timer = null;
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.setAttribute('data-active', k === i ? 'true' : 'false'); });
      if (onChange) onChange(i);
    }
    function play() { if (reduceMotion || slides.length < 2) return; stop(); timer = window.setInterval(function () { show(i + 1); }, interval); }
    function stop() { if (timer) window.clearInterval(timer); timer = null; }
    return { show: show, play: play, stop: stop };
  }

  function initAnnouncement() {
    var track = $('[data-n-announce]');
    if (!track) return;
    var msgs = $$('.n-announce__msg', track);
    var r = rotator(msgs, parseInt(track.getAttribute('data-n-interval'), 10) || 5000);
    track.addEventListener('mouseenter', r.stop);
    track.addEventListener('mouseleave', r.play);
    r.play();
  }

  /* ----------------------------------------------------------- videos
   * Muted, looping videos play only while on screen, and not at all for
   * visitors who ask for reduced motion (they keep the poster frame). A
   * [data-n-mute] button next to a video toggles its sound. */
  function initVideos() {
    // A video meant for one kind of screen carries its source in data-n-src
    // and its screen in data-n-media (phones when it has none), so the other
    // screen never downloads it. Attached when the screen matches, and again
    // if the window is later resized across the breakpoint.
    var phones = window.matchMedia('(max-width: 859px)');
    var desktops = window.matchMedia('(min-width: 860px)');
    // A video is only fetched after the page has finished loading: the still
    // carries the hero until then. "fast" skips slow connections and data
    // saver; "always" ignores the connection check; "never" leaves the still.
    function connectionOk(mode) {
      if (mode === 'never') return false;
      if (mode === 'always') return true;
      var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (!c) return true;
      if (c.saveData) return false;
      return ['slow-2g', '2g', '3g'].indexOf(c.effectiveType) === -1;
    }
    // Android Chrome can refuse a muted autoplay (straight after load(), in
    // Battery or Data Saver): retry once the video can play, and failing
    // that on the visitor's first touch or scroll, instead of leaving the
    // still in place for good.
    function playSafely(v) {
      if (reduceMotion) return;
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      var pr = v.play();
      if (!pr || !pr.catch) return;
      pr.catch(function () {
        var retry = function () {
          window.removeEventListener('touchstart', retry);
          window.removeEventListener('scroll', retry);
          var slide = v.closest('[data-n-slide]');
          if (slide && slide.getAttribute('data-active') === 'false') return;
          var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {});
        };
        v.addEventListener('canplay', retry, { once: true });
        window.addEventListener('touchstart', retry, { passive: true, once: true });
        window.addEventListener('scroll', retry, { passive: true, once: true });
      });
    }
    window.NoorePlayVideo = playSafely;

    function attachMobile() {
      $$('[data-n-src]').forEach(function (v) {
        if (v.dataset.nAttached) return;
        var media = v.getAttribute('data-n-media') || '(max-width: 859px)';
        if (!window.matchMedia(media).matches) return;
        if (!connectionOk(v.getAttribute('data-n-play') || 'fast')) return;
        v.dataset.nAttached = '1';
        var poster = v.getAttribute('data-n-poster');
        if (poster) v.poster = poster;
        v.src = v.getAttribute('data-n-src');
        v.load();
        var slide = v.closest('[data-n-slide]');
        if (slide && slide.getAttribute('data-active') === 'false') return;
        playSafely(v);
      });
    }
    // after load, and when the browser is idle, so it never competes with
    // the hero image, the fonts or the first render
    function attachWhenIdle() {
      // requestIdleCallback's second argument is an options object; passing
      // setTimeout's delay to it throws in Chrome (Android), which left the
      // phone video unattached there while Safari, without it, played it.
      var go = function () {
        if (window.requestIdleCallback) window.requestIdleCallback(attachMobile, { timeout: 2000 });
        else window.setTimeout(attachMobile, 1);
      };
      if (document.readyState === 'complete') go();
      else window.addEventListener('load', go);
    }
    attachWhenIdle();
    if (phones.addEventListener) {
      phones.addEventListener('change', attachWhenIdle);
      desktops.addEventListener('change', attachWhenIdle);
    }
    // The hero calls this when a slide is shown for the first time and its
    // video source has just been put in place.
    window.NooreAttachMobileVideo = attachMobile;

    var vids = $$('[data-n-video]');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.removeAttribute('autoplay'); });
    if (reduceMotion) { vids.forEach(function (v) { v.pause(); }); }
    else if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            // no source yet, or a hero slide that is not being shown
            if (!e.target.currentSrc && !e.target.src && !e.target.querySelector('source')) return;
            var sl = e.target.closest('[data-n-slide]');
            if (sl && sl.getAttribute('data-active') === 'false') return;
            var pr = e.target.play(); if (pr && pr.catch) pr.catch(function () {});
          }
          else e.target.pause();
        });
      }, { threshold: 0.2 });
      vids.forEach(function (v) { io.observe(v); });
    }
    $$('[data-n-mute]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = document.getElementById(btn.getAttribute('data-n-mute'));
        if (!v) return;
        v.muted = !v.muted;
        if (!v.muted) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
        btn.setAttribute('aria-pressed', String(!v.muted));
        btn.setAttribute('aria-label', v.muted ? 'Unmute video' : 'Mute video');
      });
    });
  }

  /* --------------------------------------------------- hover images
   * A product card's second photo only ever shows on hover, so it is not
   * downloaded on touch screens at all; on a mouse it loads the first time
   * the card is hovered (or focused). */
  function initHoverImages() {
    var imgs = $$('[data-n-hover-src]');
    if (!imgs.length) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    imgs.forEach(function (img) {
      var card = img.closest('.n-tile, .n-card') || img.parentElement;
      var load = function () {
        if (img.src) return;
        img.srcset = img.getAttribute('data-n-hover-srcset') || '';
        img.src = img.getAttribute('data-n-hover-src');
      };
      card.addEventListener('mouseenter', load, { once: true });
      card.addEventListener('focusin', load, { once: true });
    });
  }

  /* ------------------------------------------------------------- tabs
   * [data-n-tabs] holds [data-n-tab] buttons and/or a [data-n-tab-select],
   * and [data-n-panel] panels with matching numbers. Arrow keys move along
   * the tab list. */
  function initTabs() {
    $$('[data-n-tabs]').forEach(function (root) {
      var tabs = $$('[data-n-tab]', root);
      var select = $('[data-n-tab-select]', root);
      function show(n) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-n-tab') === n)); });
        $$('[data-n-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-n-panel') !== n; });
        if (select && select.value !== n) { select.value = n; select.dispatchEvent(new Event('n:sync')); }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t.getAttribute('data-n-tab')); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          e.preventDefault();
          var next = tabs[(i + d + tabs.length) % tabs.length];
          next.focus(); show(next.getAttribute('data-n-tab'));
        });
      });
      if (select) select.addEventListener('change', function () { show(select.value); });
    });
  }

  /* --------------------------------------------------------- carousels
   * A [data-n-carousel] is a native scroll-snap row, so touch and trackpad
   * swiping need no script. [data-n-prev]/[data-n-next] buttons move it by
   * one card and disable themselves at either end. */
  function initCarousels() {
    $$('[data-n-carousel]').forEach(function (track) {
      var prev = $('[data-n-prev="' + track.id + '"]');
      var next = $('[data-n-next="' + track.id + '"]');
      function step() {
        var card = track.firstElementChild;
        if (!card) return track.clientWidth;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------------------------------------------------------- drawers */
  var drawers = { open: null, close: null };
  function initDrawers() {
    var scrim = $('[data-n-scrim]');
    var current = null, opener = null;

    function close() {
      if (!current) return;
      current.setAttribute('data-open', 'false');
      current.setAttribute('aria-hidden', 'true');
      if (scrim) scrim.setAttribute('data-open', 'false');
      document.body.removeAttribute('data-locked');
      $$('[data-n-drawer-open="' + current.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (opener && document.contains(opener)) opener.focus();
      current = null; opener = null;
    }
    function open(drawer, trigger) {
      if (!drawer) return;
      if (current && current !== drawer) close();
      current = drawer; opener = trigger || document.activeElement;
      drawer.setAttribute('data-open', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      if (scrim) scrim.setAttribute('data-open', 'true');
      document.body.setAttribute('data-locked', 'true');
      $$('[data-n-drawer-open="' + drawer.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      var focusable = $('[data-n-drawer-close]', drawer);
      if (focusable) window.setTimeout(function () { focusable.focus(); }, 60);
    }
    drawers.open = function (id) { open(document.getElementById(id)); };
    drawers.close = close;

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-n-drawer-open]');
      if (t) {
        var d = document.getElementById(t.getAttribute('data-n-drawer-open'));
        if (!d) return;
        e.preventDefault();
        if (current === d) close(); else open(d, t);
        return;
      }
      if (e.target.closest('[data-n-drawer-close]')) close();
    });
    if (scrim) scrim.addEventListener('click', close);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ------------------------------------------------------------- cart */
  var routes = cfg.routes || {};
  var R = {
    add: (routes.cartAdd || '/cart/add') + '.js',
    change: (routes.cartChange || '/cart/change') + '.js',
    get: (routes.cart || '/cart') + '.js',
    cart: routes.cart || '/cart'
  };

  function request(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Accept': 'application/json' } }, opts || {}))
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong.');
          return data;
        });
      });
  }
  function postJSON(url, body) {
    return request(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }

  // Words written entirely in capitals become title case, as in noore-title.liquid.
  function titleCase(s) {
    return String(s == null ? '' : s).split(' ').map(function (w) {
      return (w.length > 1 && w === w.toUpperCase() && w !== w.toLowerCase()) ? w.charAt(0) + w.slice(1).toLowerCase() : w;
    }).join(' ');
  }

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function lineHTML(item, index) {
    var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
    var variant = item.product_has_only_default_variant ? '' : '<span class="n-line__variant">' + esc(item.variant_title) + '</span>';
    var sale = item.original_line_price > item.final_line_price;
    var was = sale ? '<s>' + rupees(item.original_line_price) + '</s>' : '';
    var line = index + 1;
    return '<div class="n-line">' +
      '<a class="n-line__imgwrap" href="' + esc(item.url) + '" tabindex="-1" aria-hidden="true">' + (img ? '<img class="n-line__img" src="' + esc(img) + '" alt="" width="96" height="96">' : '') + '</a>' +
      '<div class="n-line__main">' +
        '<a class="n-line__title" href="' + esc(item.url) + '">' + esc(titleCase(item.product_title)) + '</a>' + variant +
        '<span class="n-line__price"><span class="' + (sale ? 'is-sale' : '') + '">' + rupees(item.final_line_price) + '</span>' + was + '</span>' +
        '<div class="n-line__row">' +
          '<div class="n-qty">' +
            '<button type="button" data-n-line="' + line + '" data-n-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
            '<span class="n-num">' + item.quantity + '</span>' +
            '<button type="button" data-n-line="' + line + '" data-n-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
          '<button type="button" class="n-line__rm" data-n-line="' + line + '" data-n-qty="0">Remove</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  var lastCart = null;
  var cartIds = [];
  function applyUpsell(ids) {
    cartIds = ids;
    var up = $('[data-n-upsell]');
    if (!up) return;
    var max = parseInt(up.getAttribute('data-n-recs-show'), 10) || 8;
    var shown = 0;
    $$('[data-n-upsell-item]', up).forEach(function (card) {
      card.hidden = ids.indexOf(card.getAttribute('data-n-upsell-item')) > -1 || shown >= max;
      if (!card.hidden) shown++;
    });
    up.hidden = shown === 0;
  }
  function renderCart(cart) {
    if (!cart) return;
    var count = cart.item_count;

    $$('[data-n-cart-count]').forEach(function (el) {
      var changed = el.textContent !== String(count);
      el.textContent = count;
      el.hidden = count === 0;
      if (changed && count > 0 && !reduceMotion) { el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }
    });
    $$('[data-n-cart-count-inline]').forEach(function (el) { el.textContent = '(' + count + ')'; });
    $$('[data-n-cart-total]').forEach(function (el) { el.textContent = rupees(cart.total_price); });

    var root = $('[data-n-cart]');
    if (!root) return;

    var lines = $('[data-n-cart-lines]', root);
    if (lines && lines.getAttribute('data-n-synced') !== cartKey(cart)) {
      lines.innerHTML = cart.items.map(lineHTML).join('');
    }
    var empty = $('[data-n-cart-empty]', root);
    if (empty) empty.hidden = count > 0;
    var foot = $('[data-n-cart-foot]', root);
    if (foot) foot.hidden = count === 0;

    var saved = (cart.original_total_price || 0) - cart.total_price;
    var save = $('[data-n-cart-save]', root);
    if (save && save.getAttribute('data-n-synced') !== cartKey(cart)) {
      save.hidden = saved <= 0;
      var amt = $('[data-n-cart-save-amt]', save);
      if (amt) amt.textContent = rupees(saved);
    }

    /* Cart goals: one tier per reward the shopper can unlock (free shipping,
     * then each automatic discount). The bar fills towards the largest tier,
     * every tier has a tick that lights up once passed, and the line above
     * names the next one and what it still needs. */
    var block = $('[data-n-goal-block]', root);
    if (block) {
      var tiers = block.goalTiers;
      if (!tiers) {
        try { tiers = JSON.parse(block.getAttribute('data-n-goals') || '[]'); } catch (e) { tiers = []; }
        tiers = tiers.filter(function (t) { return t && t.amount > 0; })
                     .sort(function (a, b) { return a.amount - b.amount; });
        block.goalTiers = tiers;
      }
      if (tiers.length) {
        /* The subtotal before the automatic discounts, because that is what
         * Shopify measures a discount's minimum against. Taking the total
         * after discounts would make the bar fall back as each tier is
         * reached. */
        var total = cart.items_subtotal_price;
        if (typeof total !== 'number') total = cart.total_price || 0;
        var top = tiers[tiers.length - 1].amount;
        var next = null, last = null;
        tiers.forEach(function (t) { if (total >= t.amount) last = t; else if (!next) next = t; });

        block.hidden = count === 0;
        block.classList.toggle('is-met', !next);
        $('[data-n-goal-bar]', block).style.width = Math.min(100, Math.round(total / top * 100)) + '%';
        var track = $('[data-n-goal-track]', block);
        if (track) track.setAttribute('aria-valuenow', Math.round(Math.min(total, top) / 100));

        $$('[data-n-goal-step]', block).forEach(function (st) {
          var at = parseInt(st.getAttribute('data-n-goal-step'), 10) || 0;
          st.classList.toggle('is-met', total >= at);
          st.classList.toggle('is-next', !!next && at === next.amount);
        });

        var msg = next
          ? 'Add <b>' + rupees(next.amount - total) + '</b> more for <b>' + next.label + '</b>'
              + (next.note ? ' <span class="n-goal__note">' + next.note + '</span>' : '') + '.'
          : "You've unlocked <b>" + tiers[tiers.length - 1].label + '</b> — the best we have.';
        if (last && next) msg = '<span class="n-goal__won">' + last.label + ' unlocked.</span> ' + msg;
        $('[data-n-goal-msg]', block).innerHTML = msg;
      } else {
        block.hidden = true;
      }
    }

    // Don't offer something that is already in the cart.
    // Don't offer something already in the cart, and show at most the
    // configured number of suggestions.
    lastCart = cart;
    applyUpsell(cart.items.map(function (i) { return String(i.product_id); }));
    if (recs.update) recs.update(cart.items.map(function (i) { return String(i.product_id); }));
  }

  /* ------------------------------------------------ cart suggestions
   * "Trending now" in the cart. The collection's products are shuffled on
   * every page load, so a refresh or a new visitor sees a different set.
   * In "personal" mode, once the cart has items, Shopify's Product
   * Recommendations for the newest item replace them (behaviour-based,
   * served by Shopify, no app), rendered by sections/noore-cart-recs so the
   * cards match. An empty cart brings the shuffled collection back. */
  var recs = { update: null };
  function initRecs() {
    var up = $('[data-n-upsell]');
    var track = up && $('[data-n-upsell-track]', up);
    if (!up || !track) return;
    var sheetPanel = $('[data-n-sheet] .n-sheet__panel');

    if (up.getAttribute('data-n-recs-shuffle') !== 'false') {
      var cards = Array.prototype.slice.call(track.children);
      for (var i = cards.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = cards[i]; cards[i] = cards[j]; cards[j] = t;
      }
      cards.forEach(function (c) { track.appendChild(c); });
    }
    var initial = (up.getAttribute('data-n-cart-ids') || '').split(',').filter(Boolean);
    applyUpsell(initial);
    var fallback = { cards: track.innerHTML, panels: sheetPanel ? $$('[data-n-sheet-panel]', sheetPanel).map(function (p) { return p.outerHTML; }).join('') : '' };
    if (up.getAttribute('data-n-recs') !== 'personal') return;

    var intent = up.getAttribute('data-n-recs-intent') || 'related';
    var showing = 'fallback', loading = null, cache = {};
    function swap(cardsHtml, panelsHtml, key) {
      track.innerHTML = cardsHtml;
      if (sheetPanel) {
        $$('[data-n-sheet-panel]', sheetPanel).forEach(function (p) { p.remove(); });
        sheetPanel.insertAdjacentHTML('beforeend', panelsHtml);
      }
      showing = key;
      applyUpsell(cartIds);
    }
    // ids: product ids in the cart, newest first.
    recs.update = function (ids) {
      if (!ids || !ids.length) { if (showing !== 'fallback') swap(fallback.cards, fallback.panels, 'fallback'); return; }
      var pid = ids[0];
      if (showing === pid || loading === pid) return;
      if (cache[pid]) { if (cache[pid].cards) swap(cache[pid].cards, cache[pid].panels, pid); return; }
      loading = pid;
      var url = (routes.root || '/').replace(/\/?$/, '/') + 'recommendations/products?product_id=' + encodeURIComponent(pid) +
        '&limit=12&intent=' + encodeURIComponent(intent) + '&section_id=noore-cart-recs';
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        loading = null;
        var doc = new DOMParser().parseFromString(html || '', 'text/html');
        var c = $('[data-n-recs-cards]', doc), pn = $('[data-n-recs-panels]', doc);
        var hasCards = c && c.querySelector('[data-n-upsell-item]');
        cache[pid] = hasCards ? { cards: c.innerHTML, panels: pn ? pn.innerHTML : '' } : { cards: '' };
        // No recommendations yet for this product: keep the collection.
        if (hasCards) swap(cache[pid].cards, cache[pid].panels, pid);
      }).catch(function () { loading = null; });
    };
    if (initial.length) recs.update(initial);
  }

  // Busy state: the checkout button shows a spinner while the cart changes.
  function cartBusy(on) {
    var root = $('[data-n-cart]');
    if (root) root.setAttribute('data-busy', on ? 'true' : 'false');
  }

  // After the fast client render, swap in the Liquid-rendered lines and saving
  // from the header section, which know each variant's compare-at price.
  function cartKey(cart) { return cart.item_count + ':' + cart.total_price + ':' + cart.items.map(function (i) { return i.key + 'x' + i.quantity; }).join(','); }

  function syncFromSection(cart) {
    var url = (routes.root || '/').replace(/\/?$/, '/') + '?sections=noore-header';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data['noore-header']) return;
        var doc = new DOMParser().parseFromString(data['noore-header'], 'text/html');
        ['[data-n-cart-lines]', '[data-n-cart-save]'].forEach(function (sel) {
          var fresh = $(sel, doc), live = $(sel);
          if (fresh && live) live.replaceWith(fresh);
          if (fresh && cart) fresh.setAttribute('data-n-synced', cartKey(cart));
        });
      })
      .catch(function () {});
  }

  // Render straight away from /cart.js so the drawer opens without waiting,
  // then refine from the section in the background; the checkout button keeps
  // its spinner until that finishes.
  var syncing = 0;
  function backgroundSync(cart) {
    syncing++;
    cartBusy(true);
    return syncFromSection(cart).then(function () {
      renderCart(cart);
      syncing--;
      if (!syncing) cartBusy(false);
    });
  }
  /* Cart apps listen for a change rather than being told about it. Most hook
   * fetch and see our /cart/add.js call by themselves; these events cover the
   * ones that wait to be notified instead. Fired in every mode: a theme cart
   * loses nothing by saying so, and an app added later works straight away. */
  function cartChanged(cart) {
    var detail = { cart: cart };
    ['cart:refresh', 'cart:updated', 'cart:change', 'cart:build'].forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
        document.documentElement.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: detail }));
      } catch (err) {}
    });
    if (window.jQuery) { try { window.jQuery('body').trigger('added_to_cart', [cart]); } catch (err) {} }
    if (window.Shopify && typeof window.Shopify.onCartUpdate === 'function') {
      try { window.Shopify.onCartUpdate(cart); } catch (err) {}
    }
  }

  function refreshCart() {
    return request(R.get).then(function (cart) {
      renderCart(cart);
      // The Liquid re-render only feeds the theme's own drawer.
      if ($('[data-n-cart]')) backgroundSync(cart);
      cartChanged(cart);
      return cart;
    });
  }

  function cartError(msg) {
    var el = $('[data-n-cart-error]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    window.setTimeout(function () { el.hidden = true; }, 6000);
  }

  function flash(btn, label) {
    if (!btn) return;
    var original = btn.innerHTML;
    btn.classList.add('is-done');
    btn.textContent = label;
    window.setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = original; }, 1400);
  }

  /* ------------------------------------------------- adding feedback
   * Every add to cart shows the same three beats on the button that was
   * pressed: a spinner while the request is out, a short "Added" once the
   * product is in the cart, then the button's own label again. The label is
   * hidden with a transparent colour rather than replaced, so buttons whose
   * text is rewritten elsewhere (the product form's running total) are left
   * intact. The spinner takes the button's own text colour. */
  var ui = cfg.ui || {};
  /* Which cart the shop uses. "theme": the slide cart in this theme.
   * "app": a cart app owns the cart, so the theme keeps out of the way and
   * only announces the change. "page": no drawer at all, the shopper is
   * taken to the cart page. */
  var cartMode = cfg.cartMode || 'theme';
  var live = null;
  function announce(msg) {
    if (!live) {
      live = document.createElement('p');
      live.className = 'n-visually-hidden';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    window.setTimeout(function () { live.textContent = msg; }, 30);
  }
  function addState(btn, state) {
    if (!btn) return;
    if (btn._nAddTimer) { window.clearTimeout(btn._nAddTimer); btn._nAddTimer = null; }
    btn.classList.remove('n-adding', 'n-added');
    btn.removeAttribute('aria-busy');
    if (!state) return;
    if (!btn.style.getPropertyValue('--n-spin-c')) btn.style.setProperty('--n-spin-c', getComputedStyle(btn).color);
    if (state === 'busy') {
      btn.classList.add('n-adding');
      btn.setAttribute('aria-busy', 'true');
    } else {
      // Wide buttons have room for the word; round icon buttons get the tick.
      var wide = btn.getBoundingClientRect().width > 90;
      btn.setAttribute('data-n-added', wide ? (ui.added || 'Added') + ' ✓' : '✓');
      btn.classList.add('n-added');
      btn._nAddTimer = window.setTimeout(function () { addState(btn, null); }, 1600);
    }
  }
  var adding = false;
  function afterAdd(title) {
    announce((title ? title + ' · ' : '') + (ui.added || 'Added') + ' to cart');
    // With a cart app, the app opens its own drawer off the events above;
    // showing ours on top of it would be two carts at once.
    if (cartMode === 'app') return;
    if (cartMode === 'page') { window.location.href = R.cart || '/cart'; return; }
    if (ui.afterAdd === 'toast') toast(title);
    else if (drawers.open) drawers.open('n-cart');
  }

  var toastEl = null, toastTimer = null;
  // A short message at the foot of the screen with one link that opens a
  // drawer (the cart, or the wishlist).
  function showToast(msg, linkLabel, drawerId) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'n-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<span class="n-toast__tick" aria-hidden="true">✓</span><span class="n-toast__msg"></span>' +
        '<button type="button" class="n-toast__link"></button>';
      document.body.appendChild(toastEl);
      toastEl.addEventListener('click', function (e) { if (e.target.closest('.n-toast__link')) hideToast(); });
    }
    $('.n-toast__msg', toastEl).textContent = msg;
    var link = $('.n-toast__link', toastEl);
    link.textContent = linkLabel;
    link.setAttribute('data-n-drawer-open', drawerId);
    toastEl.setAttribute('data-show', 'true');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(hideToast, 4000);
  }
  function toast(title) {
    showToast((title ? titleCase(title) + ' · ' : '') + (ui.added || 'Added').toLowerCase() + ' to cart', ui.toastLink || 'View cart', 'n-cart');
  }
  function hideToast() { if (toastEl) toastEl.setAttribute('data-show', 'false'); }

  // The product name for messages: the picker's own title, else the card's.
  function productTitle(el) {
    var host = el.closest('[data-n-pick-title]') || (pickSheet.from && pickSheet.from.closest('[data-n-pick-title]'));
    if (host) return host.getAttribute('data-n-pick-title');
    var card = el.closest('.n-card, .n-tile, .n-upcard, .n-pin, .n-reel');
    var t = card && $('.n-card__title, .n-tile__title, .n-upcard__title, .n-pin__title, .n-reel__cap a', card);
    return t ? t.textContent.trim() : '';
  }

  function initCart() {
    /* A page restored from the back/forward cache keeps whatever the cart
     * looked like when it was put away, which may be several changes old.
     * An ordinary load needs nothing: Liquid already drew the cart, the
     * totals and the goal bar correctly. */
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) refreshCart().catch(function () {});
    });

    document.addEventListener('click', function (e) {
      var add = e.target.closest('[data-n-add]');
      if (add) {
        e.preventDefault();
        if (add.disabled || add.classList.contains('n-adding') || adding) return;
        adding = true;
        var title = productTitle(add);
        var list = add.closest('[data-n-pick-panel], .n-psheet__body');
        if (list) list.setAttribute('data-busy', 'true');
        addState(add, 'busy');
        announce(ui.adding || 'Adding to cart…');
        cartBusy(true);
        postJSON(R.add, { items: [{ id: Number(add.getAttribute('data-n-add')), quantity: 1 }] })
          .then(refreshCart)
          .then(function () {
            addState(add, 'done');
            // Let the tick register before the picker folds away.
            var pick = add.closest('[data-n-pick]');
            var toggle = pickSheet.from || (pick && $('[data-n-pick-toggle]', pick));
            window.setTimeout(function () {
              if (pick) closePick(pick);
              pickSheet.close();
              if (toggle && toggle !== add) addState(toggle, 'done');
              if (sheet.close) sheet.close();
              afterAdd(title);
            }, 380);
          })
          .catch(function (err) { addState(add, null); pickSheet.close(); cartError(err.message); if (drawers.open) drawers.open('n-cart'); })
          .then(function () { adding = false; if (list) list.removeAttribute('data-busy'); if (!syncing) cartBusy(false); });
        return;
      }
      var line = e.target.closest('[data-n-line]');
      if (line && line.tagName === 'BUTTON') {
        e.preventDefault();
        line.classList.add('is-busy');
        cartBusy(true);
        postJSON(R.change, { line: Number(line.getAttribute('data-n-line')), quantity: Math.max(0, Number(line.getAttribute('data-n-qty'))) })
          .then(function (cart) { renderCart(cart); return backgroundSync(cart); })
          .catch(function (err) { cartError(err.message); cartBusy(false); });
      }
    });
  }

  /* ------------------------------------------------ cart size sheet
   * "Select size" on a cart upsell card opens a sheet over the drawer with
   * that product's sizes. Picking a size updates the price and the variant
   * the Add to cart button will send. */
  var sheet = { close: null };
  function initCartSheet() {
    var root = $('[data-n-sheet]');
    if (!root) return;
    var opener = null;
    function close() {
      if (root.hidden) return;
      root.hidden = true;
      $$('[data-n-sheet-panel]', root).forEach(function (p) { p.hidden = true; });
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    }
    sheet.close = close;
    document.addEventListener('click', function (e) {
      var open = e.target.closest('[data-n-sheet-open]');
      if (open) {
        var panel = $('[data-n-sheet-panel="' + open.getAttribute('data-n-sheet-open') + '"]', root);
        if (!panel) return;
        opener = open;
        $$('[data-n-sheet-panel]', root).forEach(function (p) { p.hidden = p !== panel; });
        root.hidden = false;
        var first = $('[data-n-sheet-size][aria-pressed="true"]', panel) || $('[data-n-sheet-size]', panel);
        if (first) window.setTimeout(function () { first.focus(); }, 50);
        return;
      }
      if (e.target.closest('[data-n-sheet-close]')) { close(); return; }
      var size = e.target.closest('[data-n-sheet-size]');
      if (size && !size.disabled) {
        var p = size.closest('[data-n-sheet-panel]');
        $$('[data-n-sheet-size]', p).forEach(function (b) { b.setAttribute('aria-pressed', String(b === size)); });
        $('[data-n-sheet-price]', p).textContent = size.getAttribute('data-price');
        var was = $('[data-n-sheet-was]', p);
        was.textContent = size.getAttribute('data-was') || '';
        was.hidden = !size.getAttribute('data-was');
        $('[data-n-add]', p).setAttribute('data-n-add', size.getAttribute('data-n-sheet-size'));
      }
    });
    // Escape closes the sheet before it closes the drawer.
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !root.hidden) { e.stopImmediatePropagation(); close(); }
    }, true);
  }

  function initCartOffers() {
    var panel = $('[data-n-offers]');
    if (!panel) return;
    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-n-offers-toggle]');
      if (t) {
        var open = panel.hidden;
        panel.hidden = !open;
        $$('[data-n-offers-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
        return;
      }
      var copy = e.target.closest('[data-n-copy]');
      if (copy) {
        var code = copy.getAttribute('data-n-copy');
        var done = function () { copy.textContent = 'Copied'; window.setTimeout(function () { copy.textContent = 'Copy code'; }, 1600); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(code).then(done, done); else done();
      }
    });
  }

  /* ----------------------------------------------------- product form
   * Posts the chosen variant, and the add-on when it is switched on, to
   * Shopify's cart in one request, then opens the slide cart. The button
   * label carries the running total: size price times quantity, plus the
   * add-on. With JavaScript off the form still submits normally. */
  var buyState = { price: null, available: true };

  // Ticked "complete the ritual" rows: [{ id, price }].
  function addonState(form) {
    return $$('[data-n-addonrow]', form).filter(function (row) {
      var c = $('[data-n-addon-check]', row); return c && c.checked;
    }).map(function (row) {
      var v = $('[data-n-addon-variant]', row);
      var opt = v && v.tagName === 'SELECT' ? v.options[v.selectedIndex] : v;
      return opt ? { id: Number(opt.value), price: Number(opt.getAttribute('data-price')) || 0 } : null;
    }).filter(Boolean);
  }

  function updateTotal(form) {
    form = form || $('[data-n-product-form]');
    if (!form) return;
    var buy = $('[data-n-buy]', form);
    if (!buy || buyState.price == null) return;
    var qtyEl = $('[data-n-qty-input]', form);
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var total = buyState.price * qty + addonState(form).reduce(function (sum, a) { return sum + a.price; }, 0);
    buy.disabled = !buyState.available;
    buy.innerHTML = buyState.available
      ? 'add to cart <span aria-hidden="true">·</span> <span data-n-buy-price>' + rupees(total) + '</span>'
      : 'sold out';
  }

  function initProductForm() {
    $$('[data-n-product-form]').forEach(function (form) {
      var dataEl = $('[data-n-variants]', form);
      var select = $('[data-n-variant-select]', form);
      if (dataEl && select) {
        try {
          var list = JSON.parse(dataEl.textContent);
          var cur = list.filter(function (x) { return String(x.id) === select.value; })[0] || list[0];
          if (cur) { buyState.price = cur.price; buyState.available = cur.available; }
        } catch (err) {}
      }

      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        if (adding) return;
        // The sticky bar's button submits this form too; both show progress.
        var btns = $$('[data-n-buy]', form);
        if (form.id) btns = btns.concat($$('button[form="' + form.id + '"]'));
        var qtyEl = $('[data-n-qty-input]', form);
        var items = [{ id: Number($('[name="id"]', form).value), quantity: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1) }];
        addonState(form).forEach(function (a) { items.push({ id: a.id, quantity: 1 }); });
        var titleEl = $('[data-n-product-title]') || $('h1');
        var title = titleEl ? titleEl.textContent.trim() : '';
        adding = true;
        btns.forEach(function (b) { addState(b, 'busy'); });
        announce(ui.adding || 'Adding to cart…');
        cartBusy(true);
        postJSON(R.add, { items: items })
          .then(refreshCart)
          .then(function () {
            btns.forEach(function (b) { addState(b, 'done'); });
            if (!syncing) cartBusy(false);
            afterAdd(title);
          })
          .catch(function (err) { btns.forEach(function (b) { addState(b, null); }); cartBusy(false); cartError(err.message); if (drawers.open) drawers.open('n-cart'); })
          .then(function () { adding = false; });
      });

      $$('[data-n-step]', form).forEach(function (b) {
        b.addEventListener('click', function () {
          var input = $('[data-n-qty-input]', b.parentNode);
          if (!input) return;
          input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-n-step')));
          updateTotal(form);
        });
      });
      var qtyInput = $('[data-n-qty-input]', form);
      if (qtyInput) qtyInput.addEventListener('input', function () { updateTotal(form); });

      // Add-on rows: ticking a row, or choosing another option in it,
      // updates the row's price and the Add to cart total.
      $$('[data-n-addonrow]', form).forEach(function (row) {
        var check = $('[data-n-addon-check]', row);
        var v = $('[data-n-addon-variant]', row);
        var priceEl = $('[data-n-addon-price]', row);
        var img = $('[data-n-addon-img]', row);
        function sync() {
          row.classList.toggle('is-on', check.checked);
          if (v && v.tagName === 'SELECT') {
            var opt = v.options[v.selectedIndex];
            if (priceEl && opt) priceEl.textContent = '+' + rupees(opt.getAttribute('data-price'));
            if (img && opt && opt.getAttribute('data-img')) img.src = opt.getAttribute('data-img');
          }
          updateTotal(form);
        }
        check.addEventListener('change', sync);
        // Choosing an option ticks the row: picking one means wanting it.
        if (v && v.tagName === 'SELECT') v.addEventListener('change', function () { check.checked = true; sync(); });
      });
    });
  }

  /* --------------------------------------------------------- variants */
  function initVariants() {
    var form = $('[data-n-product-form]');
    var dataEl = form && $('[data-n-variants]', form);
    var select = form && $('[data-n-variant-select]', form);
    if (!form || !dataEl || !select) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
    var groups = $$('.n-swatches', form);

    function chosen() {
      var sel = [];
      groups.forEach(function (g) {
        var on = $('.n-swatch[aria-pressed="true"]', g);
        if (!on) return;
        sel[parseInt(on.getAttribute('data-n-option'), 10) - 1] = on.getAttribute('data-n-value');
      });
      return sel;
    }
    function match(sel) {
      return variants.filter(function (v) {
        return sel.every(function (val, i) { return val == null || v.options[i] === val; });
      })[0];
    }
    function apply() {
      var v = match(chosen());
      if (!v) return;
      select.value = v.id;
      var saving = v.compare_at_price > v.price ? v.compare_at_price - v.price : 0;
      buyState.price = v.price; buyState.available = v.available;
      updateTotal(form);
      var satc = $('[data-n-satc-price]'); if (satc) satc.textContent = rupees(v.price);
      var satcWas = $('[data-n-satc-compare]'); if (satcWas) { satcWas.textContent = rupees(v.compare_at_price); satcWas.hidden = !saving; }
      var satcSale = $('[data-n-satc-sale]'); if (satcSale) satcSale.hidden = !saving;
      if (form.id) $$('button[form="' + form.id + '"]').forEach(function (b) { b.disabled = !v.available; });
      groups.forEach(function (g) {
        var on = $('.n-swatch[aria-pressed="true"]', g);
        var label = on && $('[data-n-opt-value="' + on.getAttribute('data-n-option') + '"]');
        if (label) label.textContent = on.getAttribute('data-n-value');
      });
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    groups.forEach(function (g) {
      $$('.n-swatch', g).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          $$('.n-swatch', g).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          apply();
        });
      });
    });
  }

  /* ---------------------------------------------------------- gallery */
  function initGallery() {
    var main = $('#n-pdp-img');
    var thumbs = $$('[data-n-thumb]');
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        if (t.getAttribute('aria-current') === 'true') return;
        thumbs.forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
        main.style.opacity = '0';
        window.setTimeout(function () {
          main.srcset = t.getAttribute('data-n-thumb-srcset') || '';
          main.src = t.getAttribute('data-n-thumb');
          main.style.opacity = '1';
        }, reduceMotion ? 0 : 180);
      });
    });
  }

  /* ------------------------------------------------------- accordions
   * Buttons and panels rather than <details>/<summary>, which some browsers
   * refuse to let the page style and replace with a bar of their own. The
   * panels are open in the markup so the content is readable without
   * JavaScript; the first thing this does is close the ones that should
   * start closed, and mark the group ready so the CSS can take over. */
  function initAccordions() {
    $$('[data-n-acc]').forEach(function (group) {
      var items = $$('[data-n-acc-item]', group);
      if (!items.length) return;
      group.setAttribute('data-ready', 'true');

      function set(item, open) {
        item.setAttribute('data-open', String(open));
        var btn = $('[data-n-acc-btn]', item);
        if (btn) btn.setAttribute('aria-expanded', String(open));
      }
      items.forEach(function (item) { set(item, item.getAttribute('data-open') === 'true'); });

      group.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-n-acc-btn]');
        if (!btn || !group.contains(btn)) return;
        var item = btn.closest('[data-n-acc-item]');
        if (!item) return;
        set(item, item.getAttribute('data-open') !== 'true');
      });
    });
  }

  /* ------------------------------------------------------------ hero
   * The hero slider, and only when there is more than one slide: a single
   * slide carries no markup for this to find. Slides cross-fade, the timer
   * stops whenever someone is reading or interacting, and a slide's phone
   * video is only attached the first time that slide is shown, so slides
   * nobody reaches cost nothing. */
  function initHero() {
    $$('[data-n-hero]').forEach(function (root) {
      var slides = $$('[data-n-slide]', root);
      if (slides.length < 2) return;
      var dots = $$('[data-n-hero-dot]', root);
      var delay = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var auto = root.getAttribute('data-autoplay') !== 'false' && !reduceMotion;
      var at = 0, timer = null, held = false;

      // A later slide's videos wait in data-n-hold-src until the slide is
      // first shown; moving them across lets initVideos' own rules (screen,
      // connection, after load) decide whether each is fetched at all.
      function wake(slide) {
        var held = $$('[data-n-hold-src]', slide);
        held.forEach(function (v) {
          v.setAttribute('data-n-src', v.getAttribute('data-n-hold-src'));
          v.removeAttribute('data-n-hold-src');
        });
        if (held.length && window.NooreAttachMobileVideo) window.NooreAttachMobileVideo();
      }

      function show(n) {
        at = (n + slides.length) % slides.length;
        slides.forEach(function (sl, i) {
          var on = i === at;
          sl.setAttribute('data-active', String(on));
          if (on) sl.removeAttribute('aria-hidden'); else sl.setAttribute('aria-hidden', 'true');
          var btn = $('.n-hero3__btn', sl);
          if (btn) { if (on) btn.removeAttribute('tabindex'); else btn.setAttribute('tabindex', '-1'); }
          $$('video', sl).forEach(function (vid) {
            if (!on) vid.pause();
            else if (vid.dataset.nAttached && window.NoorePlayVideo) window.NoorePlayVideo(vid);
          });
        });
        dots.forEach(function (d, i) { d.setAttribute('aria-selected', String(i === at)); });
        wake(slides[at]);
      }

      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function start() { stop(); if (auto && !held) timer = window.setInterval(function () { show(at + 1); }, delay); }
      function go(n) { show(n); start(); }
      function hold(on) { held = on; if (on) stop(); else start(); }

      var prev = $('[data-n-hero-prev]', root), next = $('[data-n-hero-next]', root);
      if (prev) prev.addEventListener('click', function () { go(at - 1); });
      if (next) next.addEventListener('click', function () { go(at + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-n-hero-dot'), 10) || 0); });
      });

      root.addEventListener('mouseenter', function () { hold(true); });
      root.addEventListener('mouseleave', function () { hold(false); });
      root.addEventListener('focusin', function () { hold(true); });
      root.addEventListener('focusout', function () { if (!root.contains(document.activeElement)) hold(false); });
      document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });

      // A sideways swipe moves a slide; a mostly-vertical drag is the page
      // scrolling and is left alone.
      var x0 = null, y0 = null;
      root.addEventListener('touchstart', function (e) {
        var t = e.touches[0]; x0 = t.clientX; y0 = t.clientY; stop();
      }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        x0 = y0 = null;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? at + 1 : at - 1);
        start();
      }, { passive: true });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(at + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(at - 1); }
      });

      show(0);
      start();
    });
  }

  /* ------------------------------------------------------- sticky ATC */
  function initStickyAtc() {
    var bar = $('[data-n-satc]');
    var anchor = $('[data-n-satc-anchor]');
    if (!bar || !anchor) return;
    // A scroll check rather than IntersectionObserver: on phones the button
    // starts below the fold, so a fast fling past it never changes its
    // intersection state and the observer would never fire.
    // Desktop "column" mode: the card is pinned to the buy column's left edge
    // and width, and shows whenever the main button is off screen, above or
    // below. Phones and "bar" mode: once the main button is scrolled past.
    // Phones: the bar is on screen the whole time by default ("always"), so
    // add to cart is never more than a thumb away; "after" keeps the older
    // behaviour of waiting until the main button is scrolled past.
    var desk = window.matchMedia('(min-width: 960px)');
    var mode = bar.getAttribute('data-desktop') || 'column';
    var mob = bar.getAttribute('data-mobile') || 'always';
    var col = anchor.closest('.n-buy3');
    var queued = false;
    function place() {
      if (!col || !desk.matches || mode !== 'column') return;
      var r = col.getBoundingClientRect();
      bar.style.setProperty('--satc-left', r.left + 'px');
      bar.style.setProperty('--satc-w', r.width + 'px');
    }
    function update() {
      queued = false;
      var r = anchor.getBoundingClientRect();
      var show;
      if (desk.matches) {
        if (mode === 'off') show = false;
        else if (mode === 'column') {
          var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--n-header-h')) || 0;
          show = r.bottom < headerH || r.top > window.innerHeight;
        } else show = r.bottom < 0;
      } else if (mob === 'off') show = false;
      else if (mob === 'always') show = true;
      else show = r.bottom < 0;
      bar.setAttribute('data-show', String(show));
    }
    window.addEventListener('scroll', function () {
      if (!queued) { queued = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', function () { place(); update(); });
    place();
    update();
  }

  /* ------------------------------------------------- card variant picker
   * A product with sizes asks for the size before adding. With a mouse the
   * sizes open in a small panel above the button. On a phone they open in a
   * sheet from the bottom of the screen instead: it sits on <body>, so no
   * swipeable row or rounded card can clip it, and it is thumb-sized. */
  var phone = window.matchMedia('(max-width: 859px), (hover: none)');

  function closePick(pick) {
    var panel = $('[data-n-pick-panel]', pick);
    var btn = $('[data-n-pick-toggle]', pick);
    if (panel) panel.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  var pickSheet = { from: null, close: function () {} };
  function initPickSheet() {
    var root = document.createElement('div');
    root.className = 'n-psheet';
    root.hidden = true;
    root.innerHTML =
      '<div class="n-psheet__scrim" data-n-psheet-close></div>' +
      '<div class="n-psheet__panel" role="dialog" aria-modal="true" aria-labelledby="n-psheet-title">' +
        '<span class="n-psheet__grip" aria-hidden="true"></span>' +
        '<div class="n-psheet__head">' +
          '<img class="n-psheet__img" alt="" width="56" height="56" hidden>' +
          '<div class="n-psheet__text"><p class="n-psheet__title" id="n-psheet-title"></p><p class="n-psheet__hint"></p></div>' +
          '<button type="button" class="n-psheet__close" data-n-psheet-close aria-label="Close">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="n-psheet__body"></div>' +
      '</div>';
    document.body.appendChild(root);
    var body = $('.n-psheet__body', root);
    var closeTimer = null;

    function close() {
      if (root.hidden || root.getAttribute('data-open') === 'false') return;
      root.setAttribute('data-open', 'false');
      if (!$('[data-n-drawer-open][aria-expanded="true"]')) document.body.removeAttribute('data-locked');
      var from = pickSheet.from;
      if (from) from.setAttribute('aria-expanded', 'false');
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () { root.hidden = true; body.innerHTML = ''; }, reduceMotion ? 0 : 260);
      // Don't pull focus back if the cart drawer has just taken it.
      if (from && document.contains(from) && !document.body.hasAttribute('data-locked')) from.focus({ preventScroll: true });
      pickSheet.from = null;
    }
    function open(pick, toggle) {
      var panel = $('[data-n-pick-panel]', pick);
      if (!panel) return;
      window.clearTimeout(closeTimer);
      pickSheet.from = toggle;
      var title = pick.getAttribute('data-n-pick-title') || productTitle(toggle);
      $('.n-psheet__title', root).textContent = titleCase(title);
      var hint = $('.n-psheet__hint', root);
      hint.textContent = ui.sheetHint || '';
      hint.hidden = !ui.sheetHint;
      var img = $('.n-psheet__img', root);
      var src = pick.getAttribute('data-n-pick-image');
      img.hidden = !src;
      if (src) img.src = src;
      body.innerHTML = panel.innerHTML;
      root.hidden = false;
      void root.offsetWidth;
      root.setAttribute('data-open', 'true');
      document.body.setAttribute('data-locked', 'true');
      toggle.setAttribute('aria-expanded', 'true');
      var first = $('[data-n-add]:not([disabled])', body);
      if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
    }
    pickSheet.open = open;
    pickSheet.close = close;

    root.addEventListener('click', function (e) { if (e.target.closest('[data-n-psheet-close]')) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') { e.stopImmediatePropagation(); close(); }
    }, true);

    // Drag the sheet down to dismiss it.
    var panelEl = $('.n-psheet__panel', root), y0 = null, dy = 0;
    panelEl.addEventListener('touchstart', function (e) {
      if (body.scrollTop > 0 && !e.target.closest('.n-psheet__head, .n-psheet__grip')) return;
      y0 = e.touches[0].clientY; dy = 0;
    }, { passive: true });
    panelEl.addEventListener('touchmove', function (e) {
      if (y0 == null) return;
      dy = Math.max(0, e.touches[0].clientY - y0);
      panelEl.style.transform = dy ? 'translateY(' + dy + 'px)' : '';
    }, { passive: true });
    panelEl.addEventListener('touchend', function () {
      if (y0 == null) return;
      panelEl.style.transform = '';
      if (dy > 80) close();
      y0 = null; dy = 0;
    });
  }

  /* An open chooser has to be wholly on screen. The panel is measured once
   * it is visible: it flips above the button when there is not enough room
   * below (and back down when there is not enough above), and is nudged
   * sideways so neither edge leaves the window. Phones use the sheet, which
   * has none of this to worry about. */
  function placePanel(pick, panel) {
    panel.style.top = panel.style.bottom = panel.style.left = panel.style.right = '';
    panel.removeAttribute('data-drop');
    if (phone.matches) return;
    var btn = $('[data-n-pick-toggle]', pick) || pick;
    var b = btn.getBoundingClientRect();
    var h = panel.offsetHeight, w = panel.offsetWidth, gap = 6, edge = 8;
    var below = window.innerHeight - b.bottom - gap;
    var above = b.top - gap;
    var up = below < h && above > below;
    panel.setAttribute('data-drop', up ? 'up' : 'down');
    if (up) { panel.style.bottom = 'calc(100% + ' + gap + 'px)'; panel.style.top = 'auto'; }
    else { panel.style.top = 'calc(100% + ' + gap + 'px)'; panel.style.bottom = 'auto'; }
    // Horizontal: start from where the stylesheet put it, then pull it back
    // inside the window if an edge is over.
    var r = panel.getBoundingClientRect();
    var shift = 0;
    if (r.right > window.innerWidth - edge) shift = window.innerWidth - edge - r.right;
    if (r.left + shift < edge) shift = edge - r.left;
    if (shift) panel.style.transform = 'translateX(' + Math.round(shift) + 'px)';
    else panel.style.transform = '';
    // Taller than the window: let it scroll rather than run off.
    panel.style.maxHeight = Math.max(160, (up ? above : below) - edge) + 'px';
    panel.style.overflowY = panel.scrollHeight > panel.clientHeight ? 'auto' : '';
  }

  function initCardPickers() {
    initPickSheet();
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-n-pick-toggle]');
      if (toggle && phone.matches) {
        var pick = toggle.closest('[data-n-pick]');
        if (pick) { e.preventDefault(); closePick(pick); pickSheet.open(pick, toggle); return; }
      }
      $$('[data-n-pick]').forEach(function (pick) {
        var panel = $('[data-n-pick-panel]', pick);
        var btn = $('[data-n-pick-toggle]', pick);
        if (!panel || !btn) return;
        if (toggle && btn === toggle) {
          var opening = panel.hidden;
          panel.hidden = !opening;
          btn.setAttribute('aria-expanded', String(opening));
          if (opening) {
            placePanel(pick, panel);
            var first = $('[data-n-add]:not([disabled])', panel);
            if (first && e.detail === 0) first.focus();
          }
        } else if (!pick.contains(e.target)) {
          closePick(pick);
        }
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('[data-n-pick]').forEach(function (pick) {
        var panel = $('[data-n-pick-panel]', pick);
        if (panel && !panel.hidden) { closePick(pick); var b = $('[data-n-pick-toggle]', pick); if (b) b.focus(); }
      });
    });

    var replacing = false;
    function replace() {
      replacing = false;
      $$('[data-n-pick]').forEach(function (pick) {
        var panel = $('[data-n-pick-panel]', pick);
        if (panel && !panel.hidden) placePanel(pick, panel);
      });
    }
    function queueReplace() { if (!replacing) { replacing = true; window.requestAnimationFrame(replace); } }
    window.addEventListener('scroll', queueReplace, { passive: true });
    window.addEventListener('resize', queueReplace);
  }

  /* ------------------------------------------------ collection: more
   * The next page of the collection is fetched as the shopper nears the end
   * of the grid and its cards are appended, until there is no next page and
   * the closing line shows. Pagination links stay for no-JS visitors. */
  function initInfinite() {
    var more = $('[data-n-infinite]');
    var grid = $('[data-n-infinite-grid]');
    if (!more || !grid || !('IntersectionObserver' in window)) return;
    more.classList.add('is-js');
    var loading = false;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || loading) return;
      var next = more.getAttribute('data-next');
      if (!next) { io.disconnect(); return; }
      loading = true;
      more.classList.add('is-loading');
      var url = next + (next.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(more.getAttribute('data-section'));
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = $('[data-n-infinite-grid]', doc);
        var newMore = $('[data-n-infinite]', doc);
        if (newGrid) Array.prototype.slice.call(newGrid.children).forEach(function (el) { grid.appendChild(el); });
        var n = newMore ? newMore.getAttribute('data-next') : '';
        more.setAttribute('data-next', n || '');
        if (!n) { $('[data-n-infinite-end]', more).hidden = false; io.disconnect(); }
      }).catch(function () {
        more.classList.remove('is-js');
        io.disconnect();
      }).then(function () {
        loading = false;
        more.classList.remove('is-loading');
      });
    }, { rootMargin: '0px 0px 600px 0px' });
    io.observe(more);
  }

  // Desktop filter dropdowns: one open at a time, closed by an outside click or Escape.
  function initFilterDrops() {
    var drops = $$('[data-n-fdrop]');
    if (!drops.length) return;
    drops.forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) drops.forEach(function (o) { if (o !== d) o.open = false; }); });
    });
    document.addEventListener('click', function (e) { drops.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') drops.forEach(function (d) { d.open = false; }); });
  }

  /* -------------------------------------------------------- dropdowns
   * Every visible <select> becomes a styled list: a button showing the
   * choice and a listbox under it (or above it, when there is no room
   * below). The real <select> stays in the form, hidden, and is kept in
   * step both ways, so form posts and existing "change" listeners work as
   * before. Mark a select [data-n-native] to keep the browser's own.
   * Keys: arrows, Home/End, Enter/Space to choose, Escape, and typing a
   * letter jumps to the next option starting with it. */
  var ddCount = 0;
  var ddOpen = null;

  function buildDropdown(select) {
    if (select._nDD) return;
    var n = ++ddCount;
    var uid = 'n-dd-' + n;
    var wrap = document.createElement('div');
    wrap.className = 'n-dd';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.id = uid + '-btn';
    btn.className = 'n-dd__btn ' + select.className;
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span class="n-dd__value"></span><svg class="n-dd__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    var list = document.createElement('ul');
    list.className = 'n-dd__list';
    list.id = uid + '-list';
    list.setAttribute('role', 'listbox');
    list.setAttribute('tabindex', '-1');
    list.hidden = true;
    btn.setAttribute('aria-controls', list.id);

    // Name the control from its <label>, and point that label at the button.
    var label = select.id ? $('label[for="' + select.id + '"]') : null;
    if (!label) label = select.closest('label');
    var labelText = select.getAttribute('aria-label') || (label ? label.textContent.trim() : '');
    if (label && label.getAttribute('for') === select.id) {
      if (!label.id) label.id = uid + '-label';
      label.setAttribute('for', btn.id);
      btn.setAttribute('aria-labelledby', label.id + ' ' + btn.id);
      list.setAttribute('aria-labelledby', label.id);
    } else if (labelText) {
      btn.setAttribute('aria-label', labelText);
      list.setAttribute('aria-label', labelText);
    }

    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    wrap.appendChild(btn);
    wrap.appendChild(list);
    select.classList.add('n-dd__native');
    select.setAttribute('tabindex', '-1');
    select.setAttribute('aria-hidden', 'true');
    if (select.disabled) btn.disabled = true;

    var opts = [], active = -1, typed = '', typedTimer = null;

    function render() {
      list.innerHTML = '';
      opts = Array.prototype.map.call(select.options, function (o, i) {
        var li = document.createElement('li');
        li.id = uid + '-o' + i;
        li.className = 'n-dd__opt';
        li.setAttribute('role', 'option');
        li.setAttribute('data-index', i);
        li.textContent = o.textContent;
        if (o.disabled) li.setAttribute('aria-disabled', 'true');
        list.appendChild(li);
        return li;
      });
      sync();
    }
    function sync() {
      var i = select.selectedIndex;
      opts.forEach(function (li, k) { li.setAttribute('aria-selected', String(k === i)); });
      $('.n-dd__value', btn).textContent = i > -1 ? select.options[i].textContent : '';
    }
    function setActive(i) {
      if (!opts.length) return;
      i = Math.max(0, Math.min(opts.length - 1, i));
      active = i;
      opts.forEach(function (li, k) { li.classList.toggle('is-active', k === i); });
      list.setAttribute('aria-activedescendant', opts[i].id);
      var li = opts[i];
      if (li.offsetTop < list.scrollTop) list.scrollTop = li.offsetTop;
      else if (li.offsetTop + li.offsetHeight > list.scrollTop + list.clientHeight) list.scrollTop = li.offsetTop + li.offsetHeight - list.clientHeight;
    }
    function step(from, dir) {
      var i = from;
      do { i += dir; } while (i >= 0 && i < opts.length && opts[i].getAttribute('aria-disabled') === 'true');
      if (i >= 0 && i < opts.length) setActive(i);
    }
    function open() {
      if (btn.disabled || !list.hidden) return;
      if (ddOpen && ddOpen !== api) ddOpen.close(false);
      ddOpen = api;
      list.hidden = false;
      wrap.classList.remove('is-up');
      var r = btn.getBoundingClientRect();
      var h = Math.min(list.scrollHeight, 280);
      var up = window.innerHeight - r.bottom < h + 12 && r.top > h + 12;
      if (up) wrap.classList.add('is-up');
      // Inside a scrolling row (e.g. the add-on carousel) the list would be
      // clipped, so it floats against the viewport instead. Not done under a
      // transformed ancestor (drawers), where fixed isn't the viewport.
      var clipped = false, transformed = false;
      for (var el = wrap.parentElement; el && el !== document.body; el = el.parentElement) {
        var cs = getComputedStyle(el);
        if (cs.transform !== 'none' || cs.filter !== 'none') { transformed = true; break; }
        if (cs.overflowX !== 'visible' || cs.overflowY !== 'visible') clipped = true;
      }
      if (clipped && !transformed) {
        list.classList.add('is-floating');
        // Follow the button while the page or the carousel moves (a
        // carousel's snap settles just after a tap); close only once the
        // button has left the screen.
        var placeFloat = function () {
          var b = btn.getBoundingClientRect();
          if (b.bottom < 0 || b.top > window.innerHeight || b.right < 0 || b.left > window.innerWidth) { close(false); return; }
          var w = Math.max(b.width, Math.min(300, window.innerWidth - 32));
          list.style.left = Math.max(16, Math.min(b.left, window.innerWidth - w - 16)) + 'px';
          list.style.width = w + 'px';
          if (up) { list.style.top = 'auto'; list.style.bottom = (window.innerHeight - b.top + 6) + 'px'; }
          else { list.style.top = (b.bottom + 6) + 'px'; list.style.bottom = 'auto'; }
        };
        placeFloat();
        floatScroll = function (e) { if (e.target !== list) window.requestAnimationFrame(function () { if (!list.hidden) placeFloat(); }); };
        window.addEventListener('scroll', floatScroll, true);
      }
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      setActive(select.selectedIndex > -1 ? select.selectedIndex : 0);
      list.focus({ preventScroll: true });
    }
    var floatScroll = null;
    function close(refocus) {
      if (list.hidden) return;
      list.hidden = true;
      if (floatScroll) { window.removeEventListener('scroll', floatScroll, true); floatScroll = null; }
      list.classList.remove('is-floating');
      list.style.left = list.style.top = list.style.bottom = list.style.width = '';
      wrap.classList.remove('is-open', 'is-up');
      btn.setAttribute('aria-expanded', 'false');
      list.removeAttribute('aria-activedescendant');
      if (ddOpen === api) ddOpen = null;
      if (refocus !== false) btn.focus({ preventScroll: true });
    }
    function choose(i) {
      var li = opts[i];
      if (!li || li.getAttribute('aria-disabled') === 'true') return;
      var changed = select.selectedIndex !== i;
      select.selectedIndex = i;
      sync();
      close();
      if (changed) {
        wrap.classList.add('is-picked');
        window.setTimeout(function () { wrap.classList.remove('is-picked'); }, 400);
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    btn.addEventListener('click', function () { if (list.hidden) open(); else close(); });
    btn.addEventListener('keydown', function (e) {
      if (['ArrowDown', 'ArrowUp', 'Enter', ' '].indexOf(e.key) > -1) { e.preventDefault(); open(); }
    });
    list.addEventListener('click', function (e) {
      var li = e.target.closest('.n-dd__opt');
      if (li) choose(Number(li.getAttribute('data-index')));
    });
    list.addEventListener('mousemove', function (e) {
      var li = e.target.closest('.n-dd__opt');
      if (li && li.getAttribute('aria-disabled') !== 'true') setActive(Number(li.getAttribute('data-index')));
    });
    list.addEventListener('keydown', function (e) {
      switch (e.key) {
        case 'ArrowDown': e.preventDefault(); step(active, 1); break;
        case 'ArrowUp': e.preventDefault(); step(active, -1); break;
        case 'Home': e.preventDefault(); step(-1, 1); break;
        case 'End': e.preventDefault(); step(opts.length, -1); break;
        case 'Enter': case ' ': e.preventDefault(); choose(active); break;
        case 'Escape': e.preventDefault(); e.stopPropagation(); close(); break;
        case 'Tab': close(false); break;
        default:
          if (e.key.length !== 1) return;
          typed += e.key.toLowerCase();
          window.clearTimeout(typedTimer);
          typedTimer = window.setTimeout(function () { typed = ''; }, 600);
          // A new letter looks past the current option; more letters refine it.
          var start = typed.length > 1 ? active : active + 1;
          for (var k = 0; k < opts.length; k++) {
            var idx = (start + k) % opts.length;
            if (opts[idx].textContent.trim().toLowerCase().indexOf(typed) === 0 && opts[idx].getAttribute('aria-disabled') !== 'true') { setActive(idx); break; }
          }
      }
    });
    list.addEventListener('focusout', function (e) { if (!wrap.contains(e.relatedTarget)) close(false); });
    // Changes made to the real select from elsewhere show on the button.
    select.addEventListener('change', sync);
    select.addEventListener('n:sync', sync);
    if (select.form) select.form.addEventListener('reset', function () { window.setTimeout(sync, 0); });

    var api = { close: close, sync: sync, render: render, wrap: wrap };
    select._nDD = api;
    render();
  }

  function initDropdowns(root) {
    if (ui.dropdowns === false) return;
    $$('select:not([data-n-native]):not([multiple]):not(.n-visually-hidden):not(.n-dd__native)', root).forEach(function (sel) {
      if (sel.getAttribute('aria-hidden') === 'true' || sel.closest('[data-n-native]')) return;
      try { buildDropdown(sel); } catch (err) { if (window.console) console.error('[noore] dropdown failed:', err); }
    });
    if (initDropdowns.bound) return;
    initDropdowns.bound = true;
    document.addEventListener('click', function (e) { if (ddOpen && !ddOpen.wrap.contains(e.target)) ddOpen.close(false); });
    window.addEventListener('resize', function () { if (ddOpen) ddOpen.close(false); });
    // Sections re-rendered in the theme editor get their dropdowns too.
    document.addEventListener('shopify:section:load', function (e) { initDropdowns(e.target); });
  }

  /* --------------------------------------------------------- wishlist
   * Hearted products are kept on this device (localStorage), so no account
   * is needed. The heart on the product page toggles the product; the
   * Wishlist drawer lists what is saved, each with a link and a remove
   * button. Every heart and count on the page stays in step. */
  function initWishlist() {
    var KEY = 'n-wishlist';
    var hearts = $$('[data-n-wish]');
    var list = $('[data-n-wish-list]');
    if (!hearts.length && !list) return;

    function read() {
      try { var v = JSON.parse(localStorage.getItem(KEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
    }
    function write(items) { try { localStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {} }
    function has(items, handle) { return items.some(function (i) { return i.handle === handle; }); }

    function render() {
      var items = read();
      $$('[data-n-wish]').forEach(function (b) {
        var on = has(items, b.getAttribute('data-handle'));
        b.setAttribute('aria-pressed', String(on));
        var name = b.getAttribute('data-title') || '';
        b.setAttribute('aria-label', (on ? 'Remove ' : 'Save ') + name + (on ? ' from wishlist' : ' to wishlist'));
      });
      $$('[data-n-wish-count]').forEach(function (c) {
        var changed = c.textContent !== String(items.length);
        c.textContent = items.length; c.hidden = !items.length;
        if (changed && items.length && c.classList.contains('n-count') && !reduceMotion) { c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump'); }
      });
      if (!list) return;
      var empty = $('[data-n-wish-empty]');
      if (empty) empty.hidden = items.length > 0;
      list.innerHTML = items.map(function (i) {
        return '<li class="n-wish__item">' +
          '<a class="n-wish__img" href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</a>' +
          '<div class="n-wish__main"><a class="n-wish__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
          (i.price ? '<span class="n-wish__price">' + esc(i.price) + '</span>' : '') + '</div>' +
          '<button type="button" class="n-wish__rm" data-n-wish-remove="' + esc(i.handle) + '" aria-label="Remove ' + esc(i.title) + ' from wishlist">' +
            '<svg viewBox="0 0 30 30" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="m8.5 8.5 13 13M21.5 8.5l-13 13"/></svg></button>' +
        '</li>';
      }).join('');
    }

    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-n-wish]');
      if (b) {
        e.preventDefault();
        var items = read();
        var handle = b.getAttribute('data-handle');
        if (has(items, handle)) {
          items = items.filter(function (i) { return i.handle !== handle; });
        } else {
          items.unshift({ handle: handle, title: b.getAttribute('data-title'), url: b.getAttribute('data-url'), image: b.getAttribute('data-image'), price: b.getAttribute('data-price') });
          b.classList.remove('is-pop'); void b.offsetWidth; b.classList.add('is-pop');
          showToast(ui.wishSaved || 'Saved to your wishlist', 'View', 'n-wish');
        }
        write(items.slice(0, 50));
        render();
        return;
      }
      var rm = e.target.closest('[data-n-wish-remove]');
      if (rm) {
        var h = rm.getAttribute('data-n-wish-remove');
        write(read().filter(function (i) { return i.handle !== h; }));
        render();
      }
    });
    // Another tab changed the list.
    window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
    render();
  }

  /* ------------------------------------------------- story & about
   * One page, two parts. The address's #anchor picks the part, whether the
   * visitor arrives from a menu link or follows one while already here, so
   * "Our story" and "About us" can link to the same page. In "tabs" mode
   * only the chosen part shows; in "stacked" mode both show and the switch
   * scrolls, following the reader. The olive pill slides between choices. */
  function initAbout() {
    var root = $('[data-n-about]');
    if (!root) return;
    var tabs = $$('[data-n-about-tab]', root);
    var panels = $$('[data-n-about-panel]', root);
    var nav = $('[data-n-about-switch]', root);
    var pill = nav && $('.n-ab-switch__pill', nav);
    var tabsMode = root.getAttribute('data-mode') === 'tabs';
    var current = null;
    root.classList.add('is-js');

    function movePill(tab) {
      if (!pill || !tab) return;
      nav.style.setProperty('--x', tab.offsetLeft + 'px');
      nav.style.setProperty('--w', tab.offsetWidth + 'px');
      nav.classList.add('is-ready');
    }
    function mark(id) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-n-about-tab') === id)); });
      movePill($('[data-n-about-tab="' + id + '"]', root));
    }
    // Bring the chosen part's top just under the header and the floating
    // switch. (The switch itself is sticky, so it can't be measured.)
    function scrollToSwitch(smooth) {
      var panel = document.getElementById(current);
      if (!panel) return;
      var headerH = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--n-header-h')) || 0;
      var pad = parseFloat(getComputedStyle(panel).paddingTop) || 0;
      var top = panel.getBoundingClientRect().top + window.pageYOffset + pad - headerH - nav.offsetHeight - 40;
      window.scrollTo({ top: Math.max(0, top), behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
    }
    function show(id, opts) {
      opts = opts || {};
      var panel = document.getElementById(id);
      if (!panel || panels.indexOf(panel) < 0) return false;
      current = id;
      mark(id);
      if (tabsMode) panels.forEach(function (p) { p.hidden = p !== panel; });
      if (opts.hash && window.history && window.history.replaceState) window.history.replaceState(null, '', '#' + id);
      if (opts.scroll) scrollToSwitch(opts.smooth);
      return true;
    }
    function fromHash(smooth) {
      var id = decodeURIComponent((window.location.hash || '').slice(1));
      if (id && show(id, { scroll: true, smooth: smooth })) return true;
      return false;
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        var id = t.getAttribute('data-n-about-tab');
        if (tabsMode && id === current) return;
        // In tabs mode, only scroll when the reader is already down the page.
        var here = document.getElementById(current);
        var deep = here && here.getBoundingClientRect().top + (parseFloat(getComputedStyle(here).paddingTop) || 0) < nav.getBoundingClientRect().bottom;
        show(id, { hash: true, scroll: !tabsMode || deep, smooth: true });
      });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var next = tabs[(i + d + tabs.length) % tabs.length];
        next.focus(); next.click();
      });
    });

    // Menu links to this page with an anchor, followed while already here.
    window.addEventListener('hashchange', function () { if (drawers.close) drawers.close(); fromHash(true); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]');
      if (!a || root.contains(a) && a.hasAttribute('data-n-about-tab')) return;
      var url;
      try { url = new URL(a.href, window.location.href); } catch (err) { return; }
      if (url.pathname !== window.location.pathname || !url.hash) return;
      var id = decodeURIComponent(url.hash.slice(1));
      if (panels.indexOf(document.getElementById(id)) < 0) return;
      e.preventDefault();
      if (drawers.close) drawers.close();
      show(id, { hash: true, scroll: true, smooth: true });
    });

    if (!fromHash(false)) show(root.getAttribute('data-start') || panels[0].id);
    // The browser's own jump to the anchor happens after load; settle it.
    window.addEventListener('load', function () { if (window.location.hash) fromHash(false); movePill($('[aria-selected="true"]', nav)); });
    window.addEventListener('resize', function () { movePill($('[aria-selected="true"]', nav)); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { movePill($('[aria-selected="true"]', nav)); });

    // Stacked: the switch follows whichever part is being read.
    if (!tabsMode && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { current = en.target.id; mark(current); } });
      }, { rootMargin: '-45% 0px -50% 0px' });
      panels.forEach(function (p) { io.observe(p); });
    }
  }

  /* ---------------------------------------------------------- reviews
   * The product page's stars and its reviews section follow Judge.me. Liquid
   * decides the first paint from Judge.me's metafield; once Judge.me's review
   * widget is on the page, the review count and average it carries are the
   * final word: no reviews hides the section and the stars, and a real count
   * shows them with Judge.me's numbers. */
  function initReviews() {
    var gates = $$('[data-n-reviews-gate]');
    var stars = $('[data-n-stars-sync]');
    if (!gates.length && !stars) return;
    var design = document.documentElement.classList.contains('design-mode');

    function read() {
      var scope = gates.length ? gates : [document];
      for (var i = 0; i < scope.length; i++) {
        var w = $('.jdgm-rev-widg[data-number-of-reviews]', scope[i]) || $('.jdgm-widget [data-number-of-reviews]', scope[i]);
        if (w) return { count: parseInt(w.getAttribute('data-number-of-reviews'), 10) || 0, score: parseFloat(w.getAttribute('data-average-rating')) || 0 };
      }
      return null;
    }
    function apply(d) {
      var has = d.count > 0 && d.score > 0;
      if (!design) gates.forEach(function (g) { g.hidden = !has; });
      if (!stars) return;
      stars.hidden = !has;
      if (!has) return;
      var score = Math.round(d.score * 10) / 10;
      $$('.n-star', stars).forEach(function (st, i) { st.style.setProperty('--f', Math.max(0, Math.min(1, d.score - i))); });
      var text = $('[data-n-stars-text]', stars); if (text) text.textContent = score + ' (' + d.count + ')';
      var label = $('[data-n-stars-label]', stars); if (label) label.setAttribute('aria-label', 'Rated ' + score + ' out of 5 from ' + d.count + ' reviews');
    }
    var d = read();
    if (d) { apply(d); return; }
    if (!('MutationObserver' in window)) return;
    var mo = new MutationObserver(function () { var r = read(); if (r) { mo.disconnect(); apply(r); } });
    (gates.length ? gates : [document.body]).forEach(function (g) {
      mo.observe(g, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-number-of-reviews'] });
    });
    window.setTimeout(function () { mo.disconnect(); }, 20000);
  }

  /* ------------------------------------------------------- chat button
   * Third-party chat buttons (Shiprocket Engage's WhatsApp by default) sit
   * fixed at the bottom-right above everything. This keeps them out of the
   * way: hidden while a drawer, sheet or modal is open, and lifted above
   * anything docked at the bottom-right (the sticky add to cart, the
   * "added" message), dropping back when those go. The app injects its
   * button after load, so it is looked for as the page changes. */
  function initChatWidget() {
    if (ui.chatAdjust === false) return;
    var sels = (ui.chatSelectors || '#startChatPopoverContainer').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var widget = null, queued = false;
    var html = document.documentElement;

    // The fixed box to move: the matched element's nearest fixed ancestor
    // (Shiprocket's popover sits inside it), or the element itself.
    function find() {
      for (var i = 0; i < sels.length; i++) {
        var el;
        try { el = document.querySelector(sels[i]); } catch (e) { el = null; }
        if (!el) continue;
        for (var n = el; n && n !== document.body; n = n.parentElement) {
          if (getComputedStyle(n).position === 'fixed') return n;
        }
        return el;
      }
      return null;
    }
    function blocking() {
      if (document.body.getAttribute('data-locked') === 'true') return true;
      var ps = $('.n-psheet'); if (ps && ps.getAttribute('data-open') === 'true') return true;
      var sh = $('[data-n-sheet]'); if (sh && !sh.hidden) return true;
      if ($('dialog[open], [aria-modal="true"]:not([hidden]):not(.n-psheet__panel):not(.n-sheet__panel)')) return true;
      return false;
    }
    function update() {
      queued = false;
      if (!widget || !document.contains(widget)) { widget = find(); if (widget) widget.classList.add('n-chatw'); }
      if (!widget) return;
      html.classList.toggle('n-chat-hide', blocking());
      // Lift above whatever is docked at the bottom-right.
      var band = window.innerWidth - 110, lift = 0;
      // Measured where each item comes to rest (bottom offset + height), not
      // mid-slide, since they animate in from below.
      $$('[data-n-satc][data-show="true"], .n-toast[data-show="true"]').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (!el.offsetHeight || r.right <= band || getComputedStyle(el).display === 'none') return;
        var bottom = parseFloat(getComputedStyle(el).bottom) || 0;
        lift = Math.max(lift, bottom + el.offsetHeight + 8);
      });
      html.style.setProperty('--n-chat-lift', lift + 'px');
    }
    function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
    new MutationObserver(queue).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-locked', 'data-open', 'data-show', 'hidden', 'open'] });
    window.addEventListener('resize', queue);
    window.addEventListener('scroll', queue, { passive: true });
    update();
  }

  /* ------------------------------------------------------------ forms */
  function initAutosubmit() {
    $$('[data-n-autosubmit]').forEach(function (el) {
      el.addEventListener('change', function () { if (el.form) el.form.submit(); });
    });
  }
  function initContact() {
    var form = $('[data-n-contact]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      var empty = $$('[required]', form).filter(function (f) { return !f.value.trim(); });
      if (empty.length) { e.preventDefault(); empty[0].focus(); }
    });
  }

  /* ------------------------------------------------------------- boot */
  function boot() {
    [
      ['fade', initFade], ['header', initHeader], ['announcement', initAnnouncement],
      ['videos', initVideos], ['hover-images', initHoverImages], ['tabs', initTabs], ['carousels', initCarousels], ['drawers', initDrawers], ['cart', initCart], ['recs', initRecs],
      ['cart-sheet', initCartSheet], ['cart-offers', initCartOffers],
      ['product-form', initProductForm], ['variants', initVariants], ['gallery', initGallery],
      ['accordions', initAccordions], ['hero', initHero], ['sticky-atc', initStickyAtc], ['card-pickers', initCardPickers],
      ['infinite', initInfinite], ['filter-drops', initFilterDrops], ['autosubmit', initAutosubmit], ['contact', initContact],
      ['dropdowns', function () { initDropdowns(); }], ['reviews', initReviews], ['about', initAbout], ['wishlist', initWishlist], ['chat-widget', initChatWidget]
    ].forEach(function (step) {
      try { step[1](); }
      catch (err) { if (window.console) console.error('[noore] ' + step[0] + ' failed:', err); }
    });
  }
  // Flag for the rescue in layout/theme.liquid: if this never becomes true
  // the script did not run (an encrypted noore.js without CryptoJS), and the
  // page loads CryptoJS and retries.
  window.NooreReady = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
